import { Pencil, RefreshCw, Upload } from 'lucide-react';

import './venue-booking-content.css';

export interface SourceChipProps {
  /** What the chip labels: the customer-facing description text or the booking photo. */
  kind: 'description' | 'photo';
  /** Who last supplied it. */
  source: 'fareharbor' | 'staff';
  /** "Name · date" of the staff edit, shown beside a staff chip. */
  who?: string | null;
}

const LABELS = {
  description: { fareharbor: 'Synced from FareHarbor', staff: 'Edited by staff' },
  photo: { fareharbor: 'Imported from FareHarbor', staff: 'Uploaded by staff' },
} as const;

const TITLES = {
  description: {
    fareharbor: 'Still synced — a FareHarbor refresh can update this text',
    staff: "Nebari's copy — FareHarbor syncs won't overwrite it",
  },
  photo: {
    fareharbor: 'Came over in the FareHarbor import',
    staff: 'Uploaded in Nebari',
  },
} as const;

/** A quiet label saying whether FareHarbor or staff supplied a piece of booking content. */
export function SourceChip({ kind, source, who }: SourceChipProps) {
  const fareharbor = source === 'fareharbor';
  const Icon = fareharbor ? RefreshCw : kind === 'photo' ? Upload : Pencil;
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        flexWrap: 'wrap',
        minWidth: 0,
      }}
    >
      <span
        className={fareharbor ? 'vbc-chip-fh' : 'vbc-chip-staff'}
        title={TITLES[kind][source]}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 5,
          height: 20,
          padding: '0 8px',
          borderRadius: 999,
          fontSize: 10.5,
          fontWeight: 700,
          whiteSpace: 'nowrap',
        }}
      >
        <Icon size={11} aria-hidden="true" />
        {LABELS[kind][source]}
      </span>
      {!fareharbor && who && (
        <span style={{ fontSize: 10.5, color: 'var(--nb-muted)', whiteSpace: 'nowrap' }}>
          {who}
        </span>
      )}
    </span>
  );
}
